import { Button } from '@apply/components';

export interface StandardModalDemoFooterProps {
    onSubmit: () => void;
}

/** Demo content for StandardModal's footer region. */
export const StandardModalDemoFooter = ({ onSubmit }: StandardModalDemoFooterProps) => {
    return (
        // Footer spreads its children apart, so push the lone Save button to the right
        <div style={{ marginLeft: 'auto' }}>
            <Button
                id='standardModalTestSubmit'
                handleClick={onSubmit}
                width='250px'
            >
                Submit
            </Button>
        </div>
    );
};
